import react, { useState } from "react";
import { Button, Text, View, StyleSheet, TextInput, Switch, Picker } from "react-native";
import { useReducer } from "react/cjs/react.production.min";
const Request = props => {
    const [name, onNameChange] = useState("");
    const [age, onAgeChange] = useState("");
    const [isEnabled, setIsEnabled] = useState(false);
    const toggleEnable = () => setIsEnabled(pre => !pre);
    const [ostan, setOstan] = useState('');
    const required = (value, tag) => {

    }
    const reducer = (state, action) => {
        
    }
  
    const initialstate = {
        name: {
            value: '',
            isValid: false,
            errorMessage: 'نام را وارد نمائید'
        },
        age: {
            value: '',
            isValid: false,
            errorMessage: 'سن را وارد نمائید'
        },
        seller: false,
        ostan: '',
        city: {
            value: '',
            isValid: false,
            errorMessage: 'شهر را وارد نمائید'
        }
    }

    const sumbitForm = () => {
        alert('اطلاعات با موفقیت ثبت شد');
    } 
    return (
        <View style={styles.container}>
            <View style={styles.form}>
                <TextInput placeholder="نام و نام خانوادگی" style={styles.TextInput} value={name}  />
                <TextInput keyboardType="numeric" placeholder="سن" style={styles.TextInput} value={age}  />
                <Text style={{ textAlign: 'center', margin: 10 }}>استان</Text>
                <Picker style={styles.picker} itemStyle={styles.pickeritem}
                    selectedValue={ostan}
                    onValueChange={value => setOstan(value)}
                >
                    <Picker.Item value="تهران" label="تهران" />
                    <Picker.Item value="اصفهان" label="اصفهان" />

                </Picker>


                <TextInput placeholder="شهرستان" style={styles.TextInput} />
                
                <Button title="ذخیره" onPress={sumbitForm} />
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor:'#e6e6e6'
    }
    ,
    form: {
        width: '80%',
        backgroundColor: '#ddd',
        borderRadius: 10,
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
         shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,           

    },
    TextInput: {
        textAlign: 'center',
        borderBottomColor: 'gray',
        borderBottomWidth: 1,
        padding: 10,
        margin: 10,
    },
    picker: {
        padding: 7, textAlign: 'right', borderRadius: 5,
    }
    ,
    pickeritem: {
        height: 44, padding: 5
    },
    isseller: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: 10
    }
})
export default Request;